import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Droplet(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { d: "M12 1.69a1 1 0 0 1 .707.293l5.66 5.66a9 9 0 1 1-12.725 0l5.65-5.66A1 1 0 0 1 12 1.69Zm0 2.415L7.058 9.057a7 7 0 1 0 9.896 0l-4.952-4.952Z" }) }));
}
